export default __webpack_public_path__ + "static/media/onboardingAside.c94b9824.png";